import { getMenuAuth } from "src/apis/authApi";
import {  useCallback, useEffect } from "react";
import useActionbarAuthStore from "src/store/useActionbarAuthStore";
import useMenuGlobalStore from "src/store/useMenuStore";
import { downloadSettingExcel } from "src/utils/blob/blobUtil";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";

import { usePRD2030_R01Store, defaultPRD2030_R01Filter, PRD2030_R01Filter } from "./Store_PRD2030_R01";
import { PRD2030_R01Dto } from "./Dto_PRD2030_R01";
import { fetchDataSetHandler, fetchFilterConfig } from "src/utils/grid/GridHandlerContent";
import { exportPRD2030_R01Excel, getPRD2030_R01AllCount, getPRD2030_R01List } from "./Api_PRD2030_R01";
import { formatDate } from "src/utils/string/stringUtil";

interface ProductResultContentProps {
    setMessage: (message: string) => void;
}

export const Content_PRD2030_R01 = (props: ProductResultContentProps) => {
    const { setMessage } = props;

    const { 
        PRD2030_R01Filter, setPRD2030_R01Filter,
        PRD2030_R01PastFilter, setPRD2030_R01PastFilter,
        PRD2030_R01List, setPRD2030_R01List, 
        setAllCount,
        setScrollTop,
    } = usePRD2030_R01Store();
    const { setLoadingSpinner } = useLoadingSpinnerStore();
    const setAuth = useActionbarAuthStore((state) => state.setAuth);

    useFetchActionbarAuth("PRD2030_R01");

    useEffect(() => {
        getMenuAuth("PRD2030_R01").then((res) => {
            setAuth(res.data);
        });
    }, []);

    const getParams = (filter: Partial<PRD2030_R01Filter>) => {
		return {
			compCd: filter.compCd,
			workplaceCd: filter.workplaceCd,
			jobTeam: filter.jobTeam,
			dateRange: filter.dateRange,
			startDate: filter.dateRange ? formatDate(filter.dateRange.from) : undefined,
			endDate: filter.dateRange ? formatDate(filter.dateRange.to) : undefined,
			closeTag: filter.closeTag,
			workEmp: filter.workEmp,
			workEmpNm: filter.workEmpNm,
		}
	}

    const renewalAllCount = useCallback(async () => {
        const response = await getPRD2030_R01AllCount(getParams(PRD2030_R01Filter));
        setAllCount(response.data.data);
        return response.data.data;
    }, [PRD2030_R01Filter, setAllCount]);

    const fetchData = useCallback(async () => {
        setScrollTop(null);
        setLoadingSpinner(true);
        try {
			
            const response = await getPRD2030_R01List(
                '',
                getParams(PRD2030_R01Filter),
                PRD2030_R01List.length ?? 0
            );

            const rawData = (response.data.data as Omit<PRD2030_R01Dto, 'valueIndex'|'orderIndex'|'orderIndexSeq'>[]).map((row, idx) => ({
                valueIndex: idx,
                orderIndex: idx + 1,
                orderIndexSeq: 0,
                ...row,
            }));

			const newList = [...rawData ] as PRD2030_R01Dto[];
            const processAllCount = await renewalAllCount();

            if (newList && newList.length > 0) {
                setPRD2030_R01PastFilter(PRD2030_R01Filter);
                setPRD2030_R01List(newList);
                ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
				
            } else {
                showWarning('데이터가 없습니다.');
                setPRD2030_R01List([]);
            }
        } catch (error) {
            console.error('데이터 조회 실패:', error);
            showWarning('데이터 조회에 실패했습니다.');
            setPRD2030_R01List([]);
        } finally {
            setLoadingSpinner(false);
        }
		setTimeout(() => { setMessage(''); }, 5000);
    }, [PRD2030_R01Filter, setPRD2030_R01List, setPRD2030_R01PastFilter, setScrollTop]);
    
    const handleExcelClick = async () => {
        const {isDefaultFilter, isDefaultPastFilter, listLength} = fetchFilterConfig(
            PRD2030_R01Filter,
            PRD2030_R01PastFilter,
            defaultPRD2030_R01Filter,
            PRD2030_R01List.length
        );

        const response = await exportPRD2030_R01Excel(
            isDefaultFilter? '' : 'search',
            getParams(PRD2030_R01Filter),
            listLength
        );
        downloadSettingExcel({
            responseData: response.data.data,
            fileName: '공정지시 조회-excel.xlsx',
        });
    };

    return {
        fetchData,
        handleExcelClick,
    };
};


